import { render, staticRenderFns } from "./myInvoice.vue?vue&type=template&id=b59b136c&scoped=true"
import script from "./myInvoice.vue?vue&type=script&lang=js"
export * from "./myInvoice.vue?vue&type=script&lang=js"
import style0 from "./myInvoice.vue?vue&type=style&index=0&id=b59b136c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b59b136c",
  null
  
)

export default component.exports